export default {"src":"/_next/static/media/secureCloudStorage.102e3bfb.svg","height":27,"width":29};